@if (device$ | async; as device) {
    <div class="emma-card__header">
        <div fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                @if (showDeviceLink) {
                    <a [routerLink]="'/device/' + device.id">{{ device?.deviceName }}</a>
                }
                @if (!showDeviceLink) {
                    <span>{{ device?.deviceName }}</span>
                }
                -
                {{ "COMPONENT.CellularSignalLevel" | translate }}
            </div>
            @if (editGraphViews) {
                <app-device-view-list [device]="device" [dataType]="dataType"></app-device-view-list>
            }
        </div>
    </div>

    @if (device.lastData && device.lastData.cellullarSignalLevel) {
        <div class="emma-card__content">
            <small>{{ device?.lastData?.cellullarSignalLevel?.timestamp | date: "medium" }}</small>
            <h2
                [ngClass]="{
                    'orange-fg': statusValue === 'warning',
                    'red-fg': statusValue === 'alarm',
                }"
            >
                {{ device?.lastData?.cellullarSignalLevel?.value | number: "1.0-1" }}%
            </h2>
            <div>
                <span
                    [ngClass]="{
                        'text-semibold': true,
                        'orange-fg': statusAvg5 === 'warning',
                        'red-fg': statusAvg5 === 'alarm',
                    }"
                >
                    {{ device?.dataAggregation?.cellullarSignalLevel.average | number: "1.0-1" }}%
                </span>
                {{ "COMPONENT.Average5" | translate }}
            </div>
        </div>
    }

    @if (!device.lastData) {
        <div class="emma-card__content emma-card__content--center">
            <small>{{ "COMPONENT.NoData" | translate }}</small>
            <div>
                <b>
                    {{ "COMPONENT.DeviceDisconnected" | translate }}
                </b>
            </div>
        </div>
    }

    @if (device.lastData) {
        <div class="emma-card__footer-full-width">
            <highcharts-chart
                [Highcharts]="Highcharts"
                [constructorType]="chart.constructor"
                [options]="chart.options"
                [(update)]="chart.update"
                style="width: 100%; display: block"
                [callbackFunction]="chartCallback"
            ></highcharts-chart>
        </div>
    }

    @if (!device.connected && device.lastData) {
        <div class="emma-card__offline">
            {{ "COMPONENT.DeviceOffline" | translate }}
        </div>
    }
}
